<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div *ngIf="loading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div *ngIf="!loading" class="p-3 h-100" style="background-color: white;">
    <div class="pt-3 px-2 bg-white d-flex flex-column h-100" style=" border:1px solid #3f3f3f53; border-radius: 20px;">
        <form [formGroup]="changePasswordForm" class="mb-4">
            <div class=" py-2 px-1">
                <label for="amount" class="label mb-0">Old Password*</label>
                <input type="password" id="amount" class="form-control input-field" formControlName="oldPassword" />
                <div class="error"
                    *ngIf="changePasswordForm.get('oldPassword')?.touched && changePasswordForm.get('oldPassword')?.hasError('required')">
                    Old password is required
                </div>
                <div class="error" *ngIf="changePasswordForm.get('oldPassword')?.touched && changePasswordForm.get('oldPassword')?.hasError('invalidOldPassword')">
                    Old password is invalid
                </div>
            </div>
            <div class=" py-2 px-1">
                <label for="amount" class="label mb-0">New Password*</label>
                <input type="password" id="amount" class="form-control input-field" formControlName="newPassword" />
                <div class="error"
                    *ngIf="changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.hasError('required')">
                    New password is required
                </div>
            </div>
            <div class=" py-2 px-1">
                <label for="amount" class="label mb-0">Confirm Password*</label>
                <input type="password" id="amount" class="form-control input-field"
                    formControlName="confirmPassword" />
                <div class="error" *ngIf="changePasswordForm.get('confirmPassword')?.touched">
                    <span *ngIf="changePasswordForm.get('confirmPassword')?.hasError('required')">
                        Confirm password is required
                    </span>
                    <span *ngIf="changePasswordForm.get('confirmPassword')?.hasError('mismatch')">
                        New password and confirm password doesn't match
                    </span>
                </div>
            </div>
            <div class=" py-2 px-1">
                <button class="btn btn-primary form-control"
                    style="background-color: #673AB7; color: #fff;border:1px solid #673AB7;"
                    [disabled]="changePasswordForm.invalid" (click)="submit()">Update</button>
            </div>
        </form>
    </div>
</div>